import { Resources, log } from "./wgProviderHelper";

import SFError from "../models/SfError";
import { removeEmptyFieldfromObject } from "../utils";

// TODO finish this!!
/*const refreshToken = async () => {
  try {
    const token = JSON.parse(localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME));
    const rawResult = await fetch(
      `https://api.developer.wegiv.co/gateway/v3.0/oauth/refresh-token`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
        body: JSON.stringify({
          locale: "en-US",
          type: "merchant-user",
          refresh_token: token.refresh_token,
          client_id: "client-5902ca0b0257bb14df426921",
          client_secret: "+N21qR4w",
        }),
      }
    );
    if (rawResult.ok) {
    }

    const result = rawResult.json();
  } catch (error) {
    throw error;
  }
};*/

const getList = async (resource, params) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    log(`GETLIST : Params ${JSON.stringify(params)}`);

    let strParams = "?";
    Object.entries(params).forEach((entry) => {
      const [key, value] = entry;
      if (value) {
        if (key === "filter") {
          //Extract filter
          Object.entries(JSON.parse(value)).forEach((entryFilter) => {
            const [key, value] = entryFilter;
            if (key === "keyword" || key === "search_term") {
              strParams += `&search_term=${value}`;
            }
          });
          const valueJson = JSON.parse(value);
          delete valueJson.keyword;
          strParams += `&${key}=${JSON.stringify(valueJson)}`;
        } else strParams += `&${key}=${value}`;
      }
    });

    log("Parameters to API:" + strParams);
    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}${strParams}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );

    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "LIST",
        message: _createNiceErrorMessage(result),
      });
    }

    const result = await rawResult.json();

    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const createwithImage = async (resource, data) => {
  try {
    const userData = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    const formData = new FormData();

    for (const name in data) {
      if (name === "image") {
        formData.append(name, data[name].rawFile);
      } else {
        if (typeof data[name] === "object") {
          formData.append(name, JSON.stringify(data[name]));
        } else {
          const cleanedData = _cleanDatabeforeFormAppend(name, data[name]);
          formData.append(name, cleanedData);
        }
      }
    }

    formData.append("realm_id", userData.realmId);

    if (userData.branchId) formData.append("branch_id", userData.branchId);
    let options = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${userData.access_token}`,
      },
    };
    delete options.headers["Content-Type"];

    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}`,
      options
    );

    if (!rawResult.ok) {
      const result = await rawResult.json();

      return {
        wgStatus: rawResult.status,
        code: "CREATE:IM",
        message: _createNiceErrorMessage(result),
      };
      // throw new SFError({
      //   status: rawResult.status,
      //   code: "CREATE",
      //   message: _createNiceErrorMessage(result),
      // });
    }

    const result = await rawResult.json();
    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const create = async (resource, data) => {
  try {
    const userData = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    log(`Create Params ${JSON.stringify(data)}`);
    let body = {
      ...data,
      realm_id: userData.realmId,
    };
    if (userData.branchId) {
      body.branch_id = userData.branchId;
    }
    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}`,
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.access_token}`,
        },
      }
    );

    if (!rawResult.ok) {
      const result = await rawResult.json();

      throw new SFError({
        status: rawResult.status,
        code: "CREATE",
        wgCode: result.code,
        message: _createNiceErrorMessage(result),
      });
    }
    const result = await rawResult.json();

    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const cleanParamsbeforeUpdate = (data) => {
  //remove null field;
  data = removeEmptyFieldfromObject(data);
  // delete data.hashtags;
  delete data.attributes;
  delete data.image_url;
  delete data.sub_category;
  delete data.category;
  delete data.time;

  return data;
};

const updatewithImage = async (resource, data) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    data = cleanParamsbeforeUpdate(data);
    const formData = new FormData();
    for (const name in data) {
      log(`${name}: ${JSON.stringify(data[name])}`);
      if (name === "id") {
      } else if (name === "image") {
        formData.append(name, data[name].rawFile);
      } else formData.append(name, data[name]);
    }

    let options = {
      method: "PATCH",
      body: formData,
      headers: {
        Authorization: `Bearer ${token.access_token}`,
      },
    };
    delete options.headers["Content-Type"];

    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}/${data.id}`,
      options
    );
    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "UPDATE",
        message: _createNiceErrorMessage(result),
      });
    }
    const result = await rawResult.json();

    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const update = async (resource, data) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    data = cleanParamsbeforeUpdate(data);
    log(`Update Params ${JSON.stringify(data)}`);

    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}/${data.id}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );
    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "UDPATE",
        message: _createNiceErrorMessage(result),
      });
    }
    const result = await rawResult.json();
    log("Updated response " + JSON.stringify(result).substring(100));
    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const getOne = async (resource, data) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    if (!token)
      throw new SFError({
        wgStatus: 402,
        code: "LOGIN01",
        message: "Please login",
      });

    const params = data.projection
      ? `projection=${JSON.stringify(data.projection)}`
      : null;

    const addon = data.addon ? `addon=${data.addon}` : null;

    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}/${data.id}?${params}&${addon}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );
    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "GET",
        message: _createNiceErrorMessage(result),
      });
    }
    const result = await rawResult.json();

    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

/** 
     * Params {"target":"product_id","id":"prodct-601a5e4993857601af676de2",
     "pagination": { "page": 1, "perPage": 25 }, "sort": { "field": "id", "order": "DESC" },
     "filter": { }
     */
const getManyReference = async (resource, data) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    log(`GetManyRef params:${resource} ${JSON.stringify(data)}`);

    let url = null;
    if (resource === "stock" && data.target === "product_id") {
      url = `${process.env.REACT_APP_API_ENDPOINT}}/stock/product/${data.id}`;
    } else {
      throw new Error("Not define resource and target ");
    }

    const rawResult = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.access_token}`,
      },
    });
    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "LIST",
        message: _createNiceErrorMessage(result),
      });
    }
    const result = await rawResult.json();
    log("GetManyRef response:" + JSON.stringify(result));
    return { ...result, wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const deleteOne = async (resource, params) => {
  try {
    const token = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
    log(`DeleteOne params:${resource} ${JSON.stringify(params)}`);

    const rawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/${resource}/${params.id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
      }
    );
    if (!rawResult.ok) {
      const result = await rawResult.json();
      throw new SFError({
        status: rawResult.status,
        code: "DELETE",
        message: _createNiceErrorMessage(result),
      });
    }

    return { wgStatus: rawResult.status };
  } catch (error) {
    throw error;
  }
};

const _getDatafromResponseOne = (resource, rawResult) => {
  let result;

  const resourceResult = Resources.find((res) => res.path === resource);

  //Special case
  if (resource === "calendar") {
    result = [];
    if (rawResult[resourceResult.one[0]])
      rawResult[resourceResult.one[0]].forEach((customer) => {
        result.push({ type: "bday", ...customer });
      });

    if (rawResult[resourceResult.one[1]])
      rawResult[resourceResult.one[0]].forEach((event) => {
        result.push({ ...event });
      });
  } else result = rawResult[resourceResult.one];

  return result;
};

const _getDatafromResponseList = (resource, rawResult) => {
  let result;
  const resourceResult = Resources.find((res) => res.path === resource);
  //Special case
  if (resource === "calendar") {
    result = [];
    if (rawResult[resourceResult.many[0]])
      rawResult[resourceResult.many[0]].forEach((customer) => {
        result.push({ type: "bday", ...customer });
      });

    if (rawResult[resourceResult.many[1]])
      rawResult[resourceResult.many[0]].forEach((event) => {
        result.push({ ...event });
      });
  } else result = rawResult[resourceResult.many];

  if (!result || result.length <= 0 || result?.[0]?.result === null) {
    return [{ total: [{ count: 0 }], result: [] }];
  }

  //First style result
  if (result[0].total && result[0].result) {
    return result;
  } else {
    return [{ total: [{ count: result.length }], result: result }];
  }
};

const _getDatafromResponseMany = (resource, rawResult) => {
  let result;

  const resourceResult = Resources.find((res) => res.path === resource);

  //Special case
  if (resource === "calendar") {
    result = [];
    if (rawResult[resourceResult.many[0]])
      rawResult[resourceResult.many[0]].forEach((customer) => {
        result.push({ type: "bday", ...customer });
      });

    if (rawResult[resourceResult.many[1]])
      rawResult[resourceResult.many[0]].forEach((event) => {
        result.push({ ...event });
      });
  } else result = rawResult[resourceResult.many];

  return { total: result.length, result };
};

const _cleanDatabeforeFormAppend = (name, data) => {
  if (name === "authorize_pin") {
    return String(data); //DOesn't work
  } else return data;
};

const cleanResultforList = (resource, rawResult) => {
  //rawResult have 2 style
  //
  //  "products": [{
  //    "total": [{ "count": 19 }],
  //"result": [{"id": ""}, ... ]
  //
  // And without total will bel like
  // producsts: [{},...]
  let result = _getDatafromResponseList(resource, rawResult);
  //Pull total data from array
  //result=>[{"total":[{"count":19}],"result":[{"id":"prodct-...

  const { total, result: resultArray } = result[0];

  return [resultArray, total.length !== 0 ? total[0].count : 0];
};

let cleanResultforMany = (resource, rawResult) => {
  //Result style
  //{{"code":"S00000","message":"Success","payload":{"products":
  //[{"id": "prodct-601a302093857601af676dc8", "type": "Product", ....
  let result = _getDatafromResponseMany(resource, rawResult);
  const { total, result: resultArray } = result;
  return [resultArray, total];
};

const cleanResultforOne = (resource, rawResult) => {
  let result = _getDatafromResponseOne(resource, rawResult);
  //Pull total data from array
  return result;
};

const _createNiceErrorMessage = (errorJson) => {
  if (
    Array.isArray(errorJson.message) &&
    errorJson.message[0] &&
    errorJson.message[0].instancePath
  ) {
    const field = errorJson.message[0].instancePath.replace("/", "");
    const reason = errorJson.message[0].message;
    return `${field} ${reason}`;
  }

  if (errorJson.message) {
    return errorJson.message;
  }
  return `Unknow error`;
};

export {
  getList,
  create,
  createwithImage,
  getOne,
  update,
  updatewithImage,
  getManyReference,
  cleanResultforList,
  cleanResultforOne,
  cleanResultforMany,
  deleteOne,
};
